import { buildExtraMiscellaneousIds } from "@/lib/booking/miscellaneous-ids";
import { parseBookingMiscellaneousParams } from "@/lib/booking/package-inclusions";
import type { BookingRentalDataQueryParams } from "@/lib/types/booking-rental";
import type { MiscellaneousMasterDataItem } from "@/lib/types/miscellaneous";

export const EMPTY_RENTAL_ADD_ONS: MiscellaneousMasterDataItem[] = [];
export const EMPTY_RENTAL_QUANTITIES: Record<string, number> = {};

export function buildBookingRentalDataParams(
  searchParams: URLSearchParams,
  addOns: MiscellaneousMasterDataItem[],
  quantities: Record<string, number>,
): BookingRentalDataQueryParams | null {
  const baseParams = parseBookingMiscellaneousParams(searchParams);
  const selectedPackage = searchParams.get("selectedPackage");

  if (!baseParams || !selectedPackage) {
    return null;
  }

  const extraMiscellaneous = buildExtraMiscellaneousIds(addOns, quantities);

  return {
    pickup_location: baseParams.pickup_location,
    return_location: baseParams.return_location,
    from_date: baseParams.from_date,
    to_date: baseParams.to_date,
    from_time: baseParams.from_time,
    to_time: baseParams.to_time,
    selected_vehicle_type_id: baseParams.selected_vehicle_type_id,
    selected_package: selectedPackage,
    ...(extraMiscellaneous.length > 0
      ? { extra_miscellaniouse: extraMiscellaneous }
      : {}),
  };
}

export function buildBookingRentalDataParamsKey(
  searchParams: URLSearchParams,
  addOns: MiscellaneousMasterDataItem[],
  quantities: Record<string, number>,
): string | null {
  const params = buildBookingRentalDataParams(searchParams, addOns, quantities);
  return params ? JSON.stringify(params) : null;
}

export function parseBookingRentalDataParamsKey(
  key: string | null,
): BookingRentalDataQueryParams | null {
  if (!key) {
    return null;
  }

  return JSON.parse(key) as BookingRentalDataQueryParams;
}
